import { Avatar } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { LIMITED_WIDTH_LARGE } from "app/styles";
import classNames from "classnames";
import { FadeCarousel } from "./FadeCarousel";

const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: theme.palette.coral100,
        color: theme.palette.grey700,
        padding: theme.spacing(3, 5),
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
        borderRadius: theme.borderRadius.default,
        boxShadow: theme.shadow.default,
    },
    cancelledCard: {
        "& $contentWrapper": {
            opacity: 0.3,
        },
    },
    contentWrapper: {
        display: "flex",
        position: "relative",
        alignItems: "center",
        [theme.breakpoints.down("lg")]: {
            alignItems: "flex-start",
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
    content: {
        width: "100%",
    },
    actionBar: {
        textAlign: "right",
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },
    avatarRoot: {
        width: 100,
        height: 100,
        marginRight: theme.spacing(4),
        borderRadius: theme.borderRadius.circular,
        cursor: "pointer",
        flexShrink: 0,
        [theme.breakpoints.down("lg")]: {
            marginBottom: theme.spacing(3),
        },
    },
}));

export const EventCard = (props: {
    pictures: string[];
    pictureOnClick?: () => void;
    information: React.ReactNode;
    actionBar?: React.ReactNode;
    containerAttributes?: any;
    cancelled?: boolean;
    classes?: any;
}) => {
    const classes = useStyles(props);
    const { pictures, information, actionBar, containerAttributes, pictureOnClick, cancelled } =
        props;

    return (
        <div
            className={classNames(classes.card, { [classes.cancelledCard]: cancelled })}
            {...containerAttributes}
        >
            <div className={classes.contentWrapper}>
                {pictures.length > 1 ? (
                    <FadeCarousel
                        images={pictures}
                        interval={5000}
                        classes={{
                            container: classes.avatarRoot,
                        }}
                    />
                ) : (
                    <Avatar
                        data-testid="teacherAvatar"
                        src={pictures[0]}
                        variant="circular"
                        onClick={pictureOnClick}
                        classes={{
                            root: classes.avatarRoot,
                        }}
                        sx={{ width: 200, height: 200 }}
                    />
                )}

                <div className={classes.content}>{information}</div>
            </div>
            <div className={classes.actionBar}>{actionBar}</div>
        </div>
    );
};

export default EventCard;
